module.exports = __webpack_public_path__ + "static/shot-fd3395f565e5a5d06d2e2f3f63873c50.png";